import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SMP_PATH } from '@/constants/paths';

/**
 * Redirects to the SMP landing page when maintenance mode is active.
 * Call this at the top of any SMP sub-page that should be blocked
 * during scheduled maintenance.
 */
export const useMaintenanceGuard = (showMaintenance: boolean) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (showMaintenance) {
      navigate(SMP_PATH, { replace: true });
    }
  }, [showMaintenance, navigate]);
};
